export default __webpack_public_path__ + "static/media/Group 1284TataNeu.3025aca6.png";